<template>
  <div class="ls-theme-cyanogen container subscribe-wrapper">
    <header class="main-header ls-md-margin-top">
      <h1 class="trade-name" >{{ basicSeller.trade_name || basicSeller.name }}</h1>
      <h3 class="subtitle">{{ $t('payments.messages.finalize_payment') }}</h3>
    </header>
    <flash-message class="container ls-sm-margin-top"></flash-message>
    <div class="ls-no-padding ls-display-flex column-reverse flex-wrap">
      <div v-if="!finished" class="col-md-8 col-lg-7 col-sm-6 no-padding">

        <div class="ls-box ls-sm-margin-bottom ls-sm-margin-top">
          <h1 class="subtitile ls-md-margin-bottom">{{ $t('payments.labels.payment_details')}}</h1>
          
          <div>
            <h3 class="text">Nome do titular</h3>
            <h2 class="ls-xs-margin-top price">{{ customerName }}</h2>

            <h3 class="text ls-md-margin-top">Email do titular</h3>
            <h2 class="ls-xs-margin-top price">{{ customerEmail }}</h2>
          </div>

          <h3 class="text ls-md-margin-top">{{ $t('payments.labels.available_balance') }}</h3>
          <h2 class="ls-xs-margin-top price">R$ {{ money.parseViewValue(yapayBalance) }}</h2>

          <div v-if="afterPayBalance >= 0">
            <h3 class="ls-md-margin-top text">{{ $t('payments.labels.available_balance_after_payment') }}</h3>
            <h2 class="ls-xs-margin-top price">R$ {{ money.parseViewValue(afterPayBalance) }}</h2>
          </div>

          <h3 v-else class="text ls-md-margin-top">{{ $t('payments.labels.insufficient_balance') }}</h3>

          <div v-if="afterPayBalance >= 0" class="col-md-12 ls-no-padding ls-md-margin-top ls-display-flex align-items-baseline">
            <label class="ls-display-flex ">
            <input
              class=""
              type="checkbox"
              v-model="recurrent" />
              <div class="ls-sm-margin-left">
                <p class="ls-no-margin"><span class="checkbox-text">{{ $t('payments.labels.recurring_balance') }}</span></p>
                <p v-if="trayAccount()" class="ls-no-margin"><span class="checkbox-text"><i>Obs: A conta utilizada para débito automático será do titular da assinatura</i></span></p>
              </div>
            </label>
          </div>

          <div class="col-md-12 col-xs-12 ls-float-right ls-no-padding ls-md-margin-top">
            <div class="col-md-6 col-xs-6 ls-no-padding">
              <button @click.prevent="logout" class="btn pay-button">{{ $t('payments.buttons.change_account') }}</button>
            </div>
            <div v-if="afterPayBalance >= 0" class="col-md-6 col-xs-6 ls-no-padding">
              <button @click.prevent="doPayment()" class="btn pay-button next ls-sm-margin-bottom ls-float-right">{{ $t('payments.buttons.pay') }}</button>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-4 col-lg-4 col-sm-6 ls-sm-margin-top ls-sm-margin-bottom no-padding">
        <div class="full-height ls-no-padding-left ls-no-padding-right">
          <invoice-details :invoice="invoice"></invoice-details>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import * as location from 'src/utils/location'
    import InvoiceDetails from './components/InvoiceDetails.vue'
    import money from 'src/utils/money'
    import MaterialInput from '../../components/shareds/MaterialInput.vue'

    export default {
      name: 'Yapay',
      components: { InvoiceDetails, MaterialInput },
      data () {
        return {
          money: money,
          yapayBalance: '',
          customerName: '',
          customerEmail: '',
          yapayToken: '',
          afterPayBalance: '',
          finished: false,
          recurrent: true,
          steps: [
            {
              description: this.$t('payments.messages.approved_by_yapay'),
              icon: 'fa fa-check-circle-o'
            },
            {
              description: this.$t('subscribe.messages.signature_will_only_be_approved_after_payment_confirmation'),
              icon: 'fa fa-file-text-o'
            },
            {
              description: this.$t('payments.messages.you_will_receive_the_billet_monthly'),
              icon: 'fa fa-calendar'
            }
          ]
        }
      },
      methods: {
        ...mapActions(['pay', 'loadInvoiceById', 'getYapayBalance', 'loadSellerData', 'logoutYapayLogin']),
        ...mapMutations(['clearYapayData', 'clearPasswordYapay', 'addFlash']),
        getUsernameFromUrl: function () {
          return location.getUsername()
        },
        removeTokenFromUrl () {
          this.yapayToken = this.$route.params.token
          window.history.replaceState(null, null, '/payment/invoice/' + this.invoice.id + '/balance/confirm/')
        },
        async loadPage () {
          this.$loader.show()
          this.removeTokenFromUrl()
          let params = {id: this.invoice.customer_id, yapay_token: this.yapayToken}
          const self = this
          await this.getYapayBalance(params).then((response) => {
            if (response && response.status !== 200 && response.status !== 304) {
              self.$router.push('/payment/invoice/' + this.invoice.id)
            }
          })
          await this.defineBalance().then(this.loaderHide)
        },
        async defineBalance () {
          if (this.yapayData) {
            this.yapayBalance = this.yapayData.available
            this.customerName = this.yapayData.trade_name || this.yapayData.company_name || this.yapayData.name
            this.customerEmail = this.yapayData.email
            this.afterPayBalance = parseFloat(this.yapayBalance) - parseFloat(this.invoice.amount_due)
          }
        },
        loaderHide () {
          setTimeout(this.$loader.hide)
        },
        logout () {
          this.clearYapayData()
          this.logoutYapayLogin(this.yapayToken)
          this.$router.push('/payment/invoice/' + this.invoice.id)
        },
        sufficientBalance () {
          this.afterPayBalance >= 0
        },
        doPayment () {
          this.$loader.show()
          let parameters = { id: this.invoice.id, yapay_token: this.yapayToken, method: 'balance', payment_method: 'pagamento_com_saldo', recurrent: this.recurrent }
          this.pay(parameters).then(this.markPaid)
        },
        markPaid (response) {
          if (response && response.status === 200) {
            this.clearYapayData()
            this.finished = true
            this.logoutYapayLogin(this.yapayToken).then(this.$router.push('/payment/invoice/' + this.invoice.id + '/balance/success'))
          } else {
            this.accountVerificationMessage(response)
          }
          this.$loader.hide()
        },
        accountVerificationMessage (response) {
          try {
            if (response.data.error.response[0] === 'Valor transacionado é maior que o limite permitido') {
              this.addFlash({ message: this.$t('payments.messages.account_verification_wiki'), type: 'ls-alert-info', hideWarning: true })
            }
          } catch (e) {
          }
        },
        trayAccount () {
          return window.location.host.split('.')[0] === 'tray'
        },
        checkInvoiceValid (response) {
          if ((response.status !== 304 && response.status !== 200) || this.invoice.status !== 'awaiting_payment') {
            this.$router.push('/payment/invoice/' + this.invoice.id)
          }
          this.loadPage()
        }
      },
      computed: {
        ...mapGetters(['basicSeller', 'invoice', 'yapayData'])
      },
      mounted () {
        this.loadInvoiceById({ invoice_id: this.$route.params.id }).then(this.checkInvoiceValid)
        this.loadSellerData(this.getUsernameFromUrl())
      }
    }
</script>
<style>
  @media (max-width: 767px)
  {
    .column-reverse {
      flex-direction: column-reverse;
    }
    .flex-wrap {
      flex-wrap: wrap;
    }
    .no-padding {
      padding: 0px;
    }
  }
</style>
<style lang="scss" scoped>
  .subtitile {
    color: #00a0c4;
    font-weight: 100;
  }
  .text {
    color: #717787;
    font-weight: 100;
   }
   .price {
      color: #1A80A3;
      font-weight: 500;
   }
   .pay-button {
      background: #1A80A3;
      border-color: #1A80A3;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 500;
    }
    pay-button:disabled,
    button[disabled] {
       background: #FFFFFF;
       color: black;
       border: 1px solid #999999;
       pointer-events: none;
    }
    .pay-button:hover {
      background-color: #00a0c4;
      background: #00a0c4;;
    }
    .align-items-baseline {
      align-items: baseline;
    }
    .payment-info {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      list-style: none;
      i {
        font-size: 40px;
        float: left;
        display: inline-block;
        padding: 0px 15px 0px 0px;
        @media screen and (max-width: 768px) {
          font-size: 28px;
          float: left;
          display: inline-block;
          padding: 0px 30px 27px 0px;
        }
      }
    }
    .checkout-details {
      display: flex;
      justify-content: stretch;
      padding: 15px;
      @media screen and (max-width: 768px) {
        display: block;
        padding: 0;
        .order-box {
          margin-bottom: 40px;
        }
      }
    }
    .checkbox-text {
      font-size: 11px;
      color:#6E6E6E;
    }
</style>



// WEBPACK FOOTER //
// CheckoutYapay.vue?09e7390a